import { VerktoyInfoState } from '@src/types/launchUserInfoType';
import { erApenVerktoy } from '@utils/utils';

import type { MittVerktoyItem, Verktoy } from '@src/types/minhelseentities';

export function getVerktoyInfoStates({
  verktoy,
  erTilgjengelig,
  erLaeringsaktivitet,
  isAuthorizedUser,
}: {
  verktoy: Verktoy;
  erTilgjengelig: boolean;
  erLaeringsaktivitet: boolean;
  isAuthorizedUser: boolean;
}): VerktoyInfoState[] {
  const states: VerktoyInfoState[] = [];

  if (!erTilgjengelig) {
    states.push(VerktoyInfoState.IkkeTilgjengelig);
    return states;
  }

  if (erTilgjengelig && isAuthorizedUser && !verktoy.KanStartesAvInnloggetBruker) {
    states.push(VerktoyInfoState.ManglendeTilgang);
  }

  if ((verktoy.Laeringsressurs.KreverForskrivning || !erApenVerktoy(verktoy.VerktoyKategori)) && !isAuthorizedUser && erTilgjengelig) {
    states.push(VerktoyInfoState.DuMaaLoggePaa);
  }

  if (verktoy.Laeringsressurs.KreverForskrivning && erTilgjengelig && !erLaeringsaktivitet) {
    states.push(VerktoyInfoState.MaaForskrives);
  }

  return states;
}

export function getVerktoyInfoStatesMineVerktoy({
  verktoy,
  erTilgjengelig,
  erLaeringsaktivitet,
  isAuthorizedUser,
}: {
  verktoy: MittVerktoyItem;
  erTilgjengelig: boolean;
  erLaeringsaktivitet: boolean;
  isAuthorizedUser: boolean;
}): VerktoyInfoState[] {
  const states: VerktoyInfoState[] = [];

  if (!erTilgjengelig) {
    states.push(VerktoyInfoState.IkkeTilgjengelig);
    return states;
  }

  if (erTilgjengelig && isAuthorizedUser && !verktoy.KanStartesAvInnloggetBruker) {
    states.push(VerktoyInfoState.ManglendeTilgang);
  }

  if (verktoy.KreverForskrivning && erTilgjengelig && !erLaeringsaktivitet) {
    states.push(VerktoyInfoState.MaaForskrives);
  }

  return states;
}
